import storage from "../storage/storage";

// 1. Fetch JSON
export async function fetchCategories() {
    //localStorage.setItem("categories", JSON.stringify(categoriesData));
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(storage.get("categories"));
        }, 500);
    });
  }

  export async function fetchCategoriesSync(data) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(storage.set("categories",data));
        }, 500);
    });
  }
  
  // 2. Find leaf
  export async function findLeaf(rootId, nodeId, leafId) {
    fetchCategories().then((data) => {
        const root = data.find(r => r.id === rootId);
        const node = root?.children?.find(n => n.id === nodeId);
        return node?.children?.find(l => l.id === leafId);
    })
    .catch((error) => {
        console.error("Error fetching categories:", error);
    });
  }
  
  // 3. Find node
  export async function findNode(rootId, nodeId) {
    fetchCategories().then((data) => {
        const root = data.find(r => r.id === rootId);
        return root?.children?.find(n => n.id === nodeId);
    })
    .catch((error) => {
        console.error("Error fetching categories:", error);
    });
  }
  
  // 4. Find root
  export async function findRoot(rootId) {
    fetchCategories().then((data) => {
        return data.find(r => r.id === rootId);
    })
    .catch((error) => {
        console.error("Error fetching categories:", error);
    });
  }
  
  // 5. Remove root
  export async function removeRoot(rootId) {
    fetchCategories().then((data) => {
        const root = data.filter(r => r.id !== rootId);
        fetchCategoriesSync(root).then(() => {
            console.log("Removed root:", root);
        });
        return root;
    })
    .catch((error) => {
        console.error("Error fetching categories:", error);
    });
  }
  
  // 6. Remove leaf
  export async function removeLeaf(rootId, nodeId, leafId) {
    fetchCategories().then((data) => {
        const newData = data.map(r => {
            if (r.id !== rootId) return r;
            return {
              ...r,
              children: r.children.map(n => {
                if (n.id !== nodeId) return n;
                return {
                  ...n,
                  children: n.children.filter(l => l.id !== leafId)
                };
              })
            };
          });
          fetchCategoriesSync(newData).then(() => {
            console.log("Removed leaf:", newData);
        });
        return newData;
    })
    .catch((error) => {
        console.error("Error fetching categories:", error);
    });
  }
  
  // 7. Remove node
  export async function removeNode(rootId, nodeId) {
    fetchCategories().then((data) => {
        const newData = data.map(r => {
            if (r.id !== rootId) return r;
            return {
              ...r,
              children: r.children.filter(n => n.id !== nodeId)
            };
          });
          fetchCategoriesSync(newData).then(() => {
            console.log("Removed node:", newData);
        });
        return newData;
    })
    .catch((error) => {
        console.error("Error fetching categories:", error);
    });
  }
  
  // 8. Modify root
  export async function modifyRoot(rootId, newRootData) {
    fetchCategories().then((data) => {
        const newData = data.map(r => r.id === rootId ? { ...r, ...newRootData } : r);
        fetchCategoriesSync(newData).then(() => {
            console.log("modifyRoot :", newData);
        });
        return newData;
    })
    .catch((error) => {
        console.error("Error fetching categories:", error);
    });
  }
  
  // 9. Modify node
  export async function modifyNode(rootId, nodeId, newNodeData) {
    fetchCategories().then((data) => {
        const newData = data.map(r => {
            if (r.id !== rootId) return r;
            return {
              ...r,
              children: r.children.map(n => n.id === nodeId ? { ...n, ...newNodeData } : n)
            };
          });
          fetchCategoriesSync(newData).then(() => {
            console.log("modifyNode :", newData);
        });
        return newData;
    })
    .catch((error) => {
        console.error("Error fetching categories:", error);
    });
  }
  
  // 10. Modify leaf
  export async function modifyLeaf(rootId, nodeId, leafId, newLeafData) {
    fetchCategories().then((data) => {
        const newData = data.map(r => {
            if (r.id !== rootId) return r;
            return {
              ...r,
              children: r.children.map(n => {
                if (n.id !== nodeId) return n;
                return {
                  ...n,
                  children: n.children.map(l => l.id === leafId ? { ...l, ...newLeafData } : l)
                };
              })
            };
          });
          fetchCategoriesSync(newData).then(() => {
            console.log("modifyLeaf :", newData);
        });
        return newData;
    })
    .catch((error) => {
        console.error("Error fetching categories:", error);
    });
  }
  
  // 11. Add root
  export async function addRoot(newRoot) {
    fetchCategories().then((data) => {
        return [...data, newRoot];
    })
    .catch((error) => {
        console.error("Error fetching categories:", error);
    });
  }
  
  // 12. Add node
  export async function addNode(rootId, newNode) {
    fetchCategories().then((data) => {
        return data.map(r => {
            if (r.id !== rootId) return r;
            return {
              ...r,
              children: [...(r.children || []), newNode]
            };
          });
    })
    .catch((error) => {
        console.error("Error fetching categories:", error);
    });
  }
  
  // 13. Add leaf
  export async function addLeaf(rootId, nodeId, newLeaf) {
    fetchCategories().then((data) => {
        return data.map(r => {
            if (r.id !== rootId) return r;
            return {
              ...r,
              children: r.children.map(n => {
                if (n.id !== nodeId) return n;
                return {
                  ...n,
                  children: [...(n.children || []), newLeaf]
                };
              })
            };
          });
    })
    .catch((error) => {
        console.error("Error fetching categories:", error);
    });
  }
  
  export function sortDataBasedOnType(data) {
    if(data)
    {
      return data?.slice()?.sort((a, b) => {
        const order = { active: 0, deactivated: 1 };
        return (order[a.status] ?? 2) - (order[b.status] ?? 2);
      })
    }
    else {
      return data;
    }
     
  }